export default __webpack_public_path__ + "static/media/skull-bones-forest.49a49d25.jpg";